// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu___3raip","item":"item___2tiTg","itemLink":"itemLink___jn2Lt","link":"link___2SjrN","group":"group___1XaYz","groupTitle":"groupTitle___jxqSF"};